import Icon from '~/components/Icon';

export type ShopNowStep = {
  icon: React.ComponentProps<typeof Icon>['icon'];
  title: string;
  description: string;
};

function StepItem({ icon, title, description }: ShopNowStep) {
  return (
    <li className="flex items-start gap-3">
      <div className="flex-grow">
        <div className="mb-1 flex items-center gap-2">
          <Icon icon={icon} className="size-6 text-black" />
          <span className="text-foreground font-semibold">{title}</span>
        </div>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
    </li>
  );
}

export default function ShopNowSteps({ steps }: { steps: ShopNowStep[] }) {
  return (
    <div className="space-y-4">
      <ol className="space-y-4">
        {steps.map((step) => (
          <StepItem
            key={step.title}
            icon={step.icon}
            title={step.title}
            description={step.description}
          />
        ))}
      </ol>
    </div>
  );
}
